export default __webpack_public_path__ + "static/media/thron.cc546425.png";